import { WbfPolicies } from '@workers-benefit-fund/shared-data'

import { Button, Icons } from 'src/common/components'

import withErrorBoundaryAndPolicyCheck from '../../../../v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import PolicyCheckHOC from '../../../../v2/commons/HOC/policyCheckHOC'
import styles from './topbar.module.scss'

import Portal from '@v2/commons/components/ResponsivePortal/ResponsivePortal.component'
import usePolicyVerification from '@v2/commons/hooks/policyVerification/usePolicyVerification'
import { useRouter } from '@v2/commons/utils/navigation'
import NycLicenseLookup from '@v2/domains/documents/components/NycLicenseLookup/NycLicenseLookup.component'
import { DEFAULT_ROUTES } from '@v2/domains/routing/types/routing.types'
import { getRoutePath } from '@v2/domains/routing/utils/route.utils'

interface TopbarProps {
  onBurgerToggle: () => void
}

const Topbar = (props: React.PropsWithChildren<TopbarProps>) => {
  const router = useRouter()
  const isVendor = usePolicyVerification(
    WbfPolicies.is_enrollment_checker_vendors_enabled,
  )

  const { onBurgerToggle, children } = props

  if (isVendor) {
    return null
  }

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.mobileBurger} onClick={onBurgerToggle}>
          <Icons.Burger />
        </div>

        {children}

        {/* TODO refactor auto margin of component wrapper and move wrapper to component */}

        <Portal.Target
          data-testid="nyc-license-lookup-desktop-card"
          className={styles.lookupButton}
          id="NYCLookupButton"
          media="desktop"
        />
      </div>

      <Portal.Wrapper id="NYCLookupButton" width={992}>
        <div className={styles.buttonsWrapper}>
          <NycLicenseLookup />
          <PolicyCheckHOC policyName="is_persons_data_loader_enabled">
            <a
              className={styles.noTextDecoration}
              onClick={() =>
                router.push(`${getRoutePath(DEFAULT_ROUTES.UPLOAD_FILE)}`)
              }
            >
              <Button className={styles.altButton} icon="Upload" size="small">
                Upload File
              </Button>
            </a>
          </PolicyCheckHOC>
        </div>
      </Portal.Wrapper>
    </>
  )
}

export default withErrorBoundaryAndPolicyCheck(Topbar, 'is_enable_topbar', true)
